import {
  Education as EducationType,
  Job,
  SelfIntro,
  Skill,
  SocialLinks,
} from "./types.ts";

export const socialLinks: SocialLinks = {
  linkedin: "https://linkedin.com/in/shihyin-sharon-wang",
  github: "https://github.com/sharonwang554",
};

export const education: EducationType[] = [
  {
    school: "Purdue University",
    schoolZh: "普渡大學",
    degree: "Bachelor of Science in Computer Science",
    degreeZh: "電腦科學系學士",
    date: "August 2019 - May 2023",
    dateZh: "2019年8月 - 2023年5月",
    location: "West Lafayette, IN, USA",
    locationZh: "美國印第安納州西拉法葉",
    concentration: "Focus: Machine Intelligence",
    concentrationZh: "主修：機器智能",
    minor: "Minor: Anthropology",
    minorZh: "輔修：人類學",
  },
  {
    school: "Kaohsiung Girls' High School",
    schoolZh: "高雄女子高級中學",
    degree: "High School Diploma",
    degreeZh: "普通科畢業",
    date: "September 2016 - June 2019",
    dateZh: "2016年9月 - 2019年6月",
    location: "Kaohsiung, Taiwan",
    locationZh: "台灣高雄",
  },
];

export const experience: Job[] = [
  {
    company: "Micron Technology",
    companyZh: "美光科技",
    title: "AI Engineer",
    titleZh: "AI工程師",
    date: "August 2024 - Present",
    dateZh: "2024年8月 - 至今",
    location: "Taichung, Taiwan",
    locationZh: "台灣台中",
    isCurrent: true,
    responsibilities: [
      "Leveraged AI-driven workflows (Repomix) and markdown knowledge bases (Obsidian) to parse, map, and document complex legacy architectures, accelerating code comprehension and feature delivery.",
      "Built an internal doc portal from scratch using a company specific variant of Docusaurus. Organized and authored all articles using the Diataxis framework, reducing onboarding friction for new developers.",
      "Modernized deployment infrastructure by migrating CI/CD pipelines from Jenkins to GitHub Actions, building reusable workflows that automated frontend deployments and improved developer velocity.",
      "Established comprehensive testing environments, integrating unit and E2E testing (Playwright/Jasmine) to ensure the reliability of production rollouts.",
      "Developing a high-impact enterprise web application (TypeScript/Angular, C#/.NET) used by global manufacturing sites to visualize complex data, accelerate defect troubleshooting, and drive root-cause analysis.",
      "Delivering secure, cross-site data access features with robust Role-Based Access Control (RBAC), ensuring strict data visibility compliance across global regions.",
      "Maintaining system integrity and technical currency by executing annual Angular upgrades, resolving cross-site calculation discrepancies, and fortifying backend credential management.",
      "Acting as the primary technical contact for stakeholders across the US, Taiwan, Singapore, Japan, and India—translating complex requirements into clear engineering specifications and managing the lifecycle from ideation to incident resolution.",
      "Led cross-departmental AI knowledge-sharing sessions and authored technical use cases that accelerated AI tool adoption and boosted engineer productivity.",
    ],
    responsibilitiesZh: [
      "運用 AI 驅動工作流程 (Repomix) 與 Markdown 知識庫 (Obsidian) 來解析、映射與記錄複雜的舊有架構，加速程式碼理解與功能交付。",
      "使用客製化的 Docusaurus 平台，從零開始建立內部文件入口網站。利用 Diataxis 框架組織和撰寫所有文章，有效降低新開發人員的學習門檻。",
      "將 CI/CD 流程從 Jenkins 遷移至 GitHub Actions，透過建立可重複使用的流程並自動化前端部署，實現部署基礎設施現代化並提升開發速度。",
      "建立全面的測試環境，整合單元測試與端到端測試 (Playwright/Jasmine)，以確保生產環境發布的可靠性。",
      "開發具高影響力的企業級網頁應用程式 (TypeScript/Angular, C#/.NET)，為全球製造廠提供複雜資料視覺化工具，加速缺陷排除並推動根本原因分析。",
      "提供安全且具備強健的基於角色存取控制 (RBAC) 的跨廠區資料存取功能，確保全球各地的資料可見性嚴格合規。",
      "透過執行年度 Angular 升級、解決跨廠區計算差異，並強化後端憑證管理，維持系統完整性與技術領先。",
      "擔任跨美國、台灣、新加坡、日本與印度之利害關係人的主要技術聯絡窗口，將複雜需求轉化為清晰的工程規格，並管理從概念發想到事件解決的完整生命週期。",
      "跨部門領導 AI 知識分享會議並撰寫技術使用案例，加速 AI 工具的採用，並提升工程師生產力。",
    ],
  },
  {
    company: "CATME Smarter Teamwork",
    companyZh: "CATME Smarter Teamwork",
    title: "Software Developer/Assistant Technical Support Team Manager",
    titleZh: "軟體工程師/技術支援團隊副經理",
    date: "July 2023 - May 2024",
    dateZh: "2023年7月 - 2024年5月",
    location: "West Lafayette, IN, USA",
    locationZh: "美國印第安納州西拉法葉",
    responsibilities: [
      "Collaborated with cross-functional teams to develop and maintain CATME, a high-traffic educational web application serving 2M+ students and 18,000+ instructors across 2,200 institutions globally.",
      "Diagnosed and resolved complex platform bugs via Zendesk, engineering Python-based analytics to monitor support metrics, identify friction points, and optimize ticket response times.",
      "Led technical onboarding and mentorship for incoming software development interns, managing weekly meetings and code reports to streamline their workflows and accelerate ramp-up time.",
    ],
    responsibilitiesZh: [
      "與跨職能團隊合作開發並維護 CATME，這是一個高流量的教育網頁應用程式，為全球 2,200 多所機構的超過 200 萬名學生與 18,000 多名教師提供服務。",
      "透過 Zendesk 診斷並解決複雜的平台錯誤，同時開發基於 Python 的分析工具來監控支援指標、找出痛點，並優化支援工單的回應時間。",
      "領導新進軟體開發實習生的技術入職與指導，管理每週會議與程式碼報告，以簡化他們的工作流程並縮短適應期。",
    ],
  },
  {
    company: "CATME Smarter Teamwork",
    companyZh: "CATME Smarter Teamwork",
    title: "Software Development Intern",
    titleZh: "軟體開發實習生",
    date: "December 2021 - May 2023",
    dateZh: "2021年12月 - 2023年5月",
    location: "West Lafayette, IN, USA",
    locationZh: "美國印第安納州西拉法葉",
    responsibilities: [
      "Maintained seamless data synchronization between the platform and Canvas LMS, leveraging OAuth 2.0 and REST APIs to build robust import/export functionality.",
      "Configured reproducible testing environments using AWS EC2 and Docker, streamlining infrastructure management and local developer workflows.",
      "Authored 40+ pages of comprehensive technical documentation, building internal architectural guides and onboarding materials for developers on my team.",
      "Produced instructional video tutorials, conducted live demos, and wrote comprehensive client-facing manuals for end users to accelerate product adoption.",
    ],
    responsibilitiesZh: [
      "維護平台與 Canvas LMS 之間無縫的資料同步，利用 OAuth 2.0 與 REST APIs 建立強健的匯入/匯出功能。",
      "使用 AWS EC2 和 Docker 配置可重製的測試環境，簡化基礎設施管理與在地開發人員的工作流程。",
      "撰寫超過 40 頁全面的技術文件，為團隊開發人員建立內部架構指南與入職教材。",
      "製作教學影片、進行實況示範，並為終端使用者編寫全面的客戶端操作手冊，以加速產品的採用。",
    ],
  },
];

export const skills: Skill[] = [
  {
    category: "programmingLanguages",
    items: [
      "TypeScript",
      "C#",
      "Markdown",
      "Java",
      "Python",
      "Sass",
    ],
  },
  {
    category: "frameworks",
    items: [
      "Angular",
      ".NET",
      "Docusaurus",
      "Astro",
      "Three.js",
      "React Three Fiber",
      // "React",
      // "Django",
      // "Flask"
    ],
  },
  {
    category: "databases",
    items: [
      "SQL",
      "MongoDB",
    ],
  },
  {
    category: "cloudTech",
    items: ["Azure", "Amazon Web Services (AWS)", "Google Cloud Platform (GCP)"],
  },
  {
    category: "cicd",
    items: [
      "GitHub Actions",
      "Docker",
      "Kubernetes",
      "OpenShift",
      // "Helm",
      // "Jenkins",
      //   "Octopus"
    ],
  },
  {
    category: "tools",
    items: [
      "Git",
      "Vim",
      "Linux",
      "Obsidian",
      "Confluence",
      // "Postman",
      //   "Snowflake",
      "Jira",
    ],
  },
  // {
  //     category: "dataPlatforms",
  //     items: ["Snowflake"]
  // }
];

export const selfIntro: SelfIntro = {
  intro:
    "I am an AI engineer at Micron Technology, where I build data visualization and analysis tools for semiconductor manufacturing using TypeScript, Angular, C#, and .NET. My work involves collaborating with international teams to turn complex yield data into actionable insights that help optimize production processes.\n\nAfter graduating from Kaohsiung Girls' High School, I went to the U.S. to study Computer Science at Purdue University, focusing on Machine Intelligence with a minor in Anthropology. This unique experience taught me to approach technical challenges with both analytical precision and human-centered thinking.\n\nWelcome to my website! 😁",
  introZh:
    "我是個目前任職於美光科技的AI工程師，主要負責開發用於半導體製造的資料視覺化與分析工具，使用的核心技術包括但不限於 TypeScript、Angular、C# 和 .NET。我的工作常常需要跟跨國團隊合作，使良率工程師們能將複雜的良率數字轉化成能優化製程的實用資訊。\n\n從高雄女中畢業後，我去了美國就讀普渡大學電腦科學系，在那裡主修了機器智能並輔修人類學。這樣的背景讓我在面對技術挑戰時除了重視精準的分析，也會從人本的角度來思考問題。\n\n歡迎來到我的網站！ 😁",
};
